<template>
  <component :is="tag" class="borderLink" :to="to" :href="href">
    {{ text }}
  </component>
</template>

<script>
export default {
  name: 'BorderLink',
  props: {
    text: {
      type: String,
      default: null,
    },
    to: {
      type: String,
      default: undefined,
    },
    href: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    tag() {
      if (this.to) {
        return 'nuxt-link';
      } else {
        return 'a';
      }
    },
  },
};
</script>

<style lang="scss">
.borderLink {
  position: relative;
  padding-bottom: 0.6rem;
  font-size: 1.2rem;
  line-height: 1.5rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-weight: 700;
  color: $cMain;
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: $cMain;
    transition: width $tr;
  }

  &:hover {
    &:before {
      width: 30%;
    }
  }
}
</style>
